// Helpers for per-location business hours:
// { mon: { open: '09:00', close: '17:00', closed: false }, ... }

export const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']; // Date.getDay() order

export const DAY_LABELS = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
};

export const dayHoursFor = (businessHours, date) => {
  if (!businessHours) return null;
  return businessHours[DAY_KEYS[new Date(date).getDay()]] || null;
};

const toDecimal = (hm) => {
  const [h, m] = String(hm || '').split(':').map(Number);
  return (h || 0) + (m || 0) / 60;
};

// True when a start time (plus optional duration) falls outside the day's hours.
export const isOutsideBusinessHours = (businessHours, start, durationMinutes = 0) => {
  const day = dayHoursFor(businessHours, start);
  if (!day) return false;
  if (day.closed) return true;
  const d = new Date(start);
  const startDec = d.getHours() + d.getMinutes() / 60;
  const endDec = startDec + (Number(durationMinutes) || 0) / 60;
  return startDec < toDecimal(day.open) || Math.max(startDec, endDec) > toDecimal(day.close);
};

// True when the [hour, hour+1) grid slot is entirely outside the day's hours.
export const hourSlotOutside = (businessHours, date, hour) => {
  const day = dayHoursFor(businessHours, date);
  if (!day) return false;
  if (day.closed) return true;
  return hour + 1 <= toDecimal(day.open) || hour >= toDecimal(day.close);
};

// Expand a fallback hour range so every configured open hour is visible.
export const hourRange = (businessHours, fallbackStart, fallbackEnd) => {
  let start = fallbackStart;
  let end = fallbackEnd;
  if (businessHours) {
    for (const day of Object.values(businessHours)) {
      if (!day || day.closed) continue;
      start = Math.min(start, Math.floor(toDecimal(day.open)));
      end = Math.max(end, Math.ceil(toDecimal(day.close)));
    }
  }
  return [start, end];
};
